import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlaySelectModel } from '../models/bettingorder.dto';

@Injectable()
export class PlaySelectService {

    public playSelect: BehaviorSubject<PlaySelectModel>;

    constructor() {
        this.playSelect = new BehaviorSubject(new PlaySelectModel());
    }

    setPlaySelectModel(playSelectModel: PlaySelectModel) {
        this.playSelect.next(playSelectModel);
    }

    getPlaySelectModel() {
        return this.playSelect.asObservable();
    }
}


// WEBPACK FOOTER //
// ./src/services/playselect.service.ts